import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-badges',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-badges works!</p> `,
  styles: ``,
})
export class CpBadgesComponent {}
